import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE_INFO, LOGO_URL } from "../mock";

const navLinks = [
  { to: "/", label: "Accueil" },
  { to: "/galerie", label: "Galerie" },
  { to: "/tarifs", label: "Tarifs" },
  { to: "/cartes-cadeaux", label: "Cartes cadeaux" },
  { to: "/reservation", label: "Réservation" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" }
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
          scrolled ? "bg-black/90 backdrop-blur-md py-2" : "bg-black/40 backdrop-blur-sm py-3"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="relative">
              <div
                className="absolute inset-0 -m-3"
                style={{
                  background: "radial-gradient(circle, rgba(245,230,200,0.55) 0%, rgba(245,230,200,0.3) 40%, rgba(201,169,97,0.15) 70%, transparent 90%)",
                  filter: "blur(10px)"
                }}
              />
              <img
                src={LOGO_URL}
                alt="Ludovic Garcia Photographe"
                className={`relative transition-all duration-300 ${scrolled ? "h-14" : "h-20"}`}
              />
            </div>
            <div className="hidden sm:flex items-baseline gap-2">
              <span
                className="text-xl md:text-2xl italic tracking-wide text-gold"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}
              >
                {SITE_INFO.name}
              </span>
              <span className="text-xs md:text-sm text-gray-400 font-light tracking-wider uppercase">
                {SITE_INFO.subtitle}
              </span>
            </div>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-xs tracking-wider uppercase transition-colors hover:text-gold ${
                  location.pathname === link.to ? "text-gold" : "text-white/80"
                }`}
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2 hover:text-gold transition-colors"
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </header>

      {/* Mobile menu */}
      <div className={`mobile-menu ${open ? "open" : ""} lg:hidden`}>
        <nav className="flex flex-col items-center gap-8">
          <div className="relative mb-4">
            <div
              className="absolute inset-0 -m-6 rounded-full"
              style={{
                background: "radial-gradient(circle, rgba(201,169,97,0.3) 0%, rgba(201,169,97,0.1) 40%, transparent 70%)",
                filter: "blur(12px)"
              }}
            />
            <img src={LOGO_URL} alt="Logo" className="relative h-28" />
          </div>
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-2xl tracking-wider uppercase transition-colors hover:text-gold ${
                location.pathname === link.to ? "text-gold" : "text-white"
              }`}
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic" }}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </>
  );
}
